import { Dispatch, RefObject, SetStateAction } from 'react';

import { useQueryClient } from '@tanstack/react-query';
import { enqueueSnackbar } from 'notistack';

import { useShowError } from 'hooks/useShowError';
import { useUploadFileMutation } from 'mutations/useUploadFileMutation';

type UseMutateImportacao = {
    file: File | null;
    setFile: Dispatch<SetStateAction<File | null>>;
    inputRef: RefObject<HTMLInputElement | null>;
};

export function useMutateImportacao({ setFile, file, inputRef }: UseMutateImportacao) {
    const { showError } = useShowError();
    const queryClient = useQueryClient();

    const { mutate, isLoading } = useUploadFileMutation({
        onSuccess: () => {
            enqueueSnackbar('Arquivo de importação enviado com sucesso', { variant: 'success' });

            setFile(null);

            if (inputRef.current) {
                inputRef.current.value = '';
            }

            queryClient.invalidateQueries(['queryImportacoes']);
        },
        onError: (error) => showError(error, 'Falha ao enviar arquivo'),
    });

    /**
     * Envia o arquivo de importação para o servidor.
     */
    const handleSubmit = () => {
        const formData = new FormData();

        if (file) {
            formData.append('file', file);

            mutate({ formData, url: '/gestao/lojaconfiguracaoimportacao/upload' });
        }
    };

    return { isLoading, handleSubmit };
}
